<template>
  <div>
    <div class="pa-3">
      <div v-if="loading" class="spinner text-xs-center">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
      <div v-else-if="type == 'Customer'">
        <div v-if="data.length">
          <div v-for="(item, k) in data" :key="k" class="my-1">
            <v-card>
              <v-card-text>
                <v-layout>
                  <v-flex xs6>
                    <div style="margin-top: 5px;" class="caption">{{ item.id }}</div>
                  </v-flex>
                  <v-flex xs6>
                    <div class="text-xs-right">
                      <v-btn
                        :color="$options.filters.statusColor(item.status)"
                        depressed
                        style="border-radius: 20px; color:white"
                        small
                        @click.stop="showDialog(item.id)"
                        rounded="true"
                        >{{ item.status }}</v-btn
                      >
                    </div>
                  </v-flex>
                </v-layout>

                <div class="mt-2">
                  <!-- <v-img style="margin-left: auto;margin-right: auto" width="50%" class="mb-3"></v-img> -->
                  <v-layout>
                    <v-flex xs5>
                      <div
                        v-if="item.customer_file"
                        style="width: 100%;height: 100px;border-radius: 5px;"
                        class="grey lighten-4 text-xs-center"
                      >
                        <img
                          v-if="item.customer_file"
                          style="max-width: 100%;height: 100%; max-height: 100px"
                          :src="'data:image/jpeg;base64,' + item.customer_file"
                          alt
                        />
                      </div>

                      <div
                        v-else
                        style="width: 100%;height: 100px;border-radius: 5px;"
                        class="grey lighten-4 text-xs-center"
                      >
                        <img
                          style="max-width: 100%;height: 100%; max-height: 100px"
                          src="/static/img/empty-img-placeholder.png"
                          alt
                        />
                      </div>
                    </v-flex>
                    <v-flex xs7 style="word-break: break-all;">
                      <div class="pl-2 mb-2">
                        <div class="caption">ประเภทรถ</div>
                        <div>{{ item.type }}</div>
                      </div>
                      <div class="pl-2 mb-2">
                        <div class="caption">รายละเอียดรถ</div>
                        <div>{{ item.subtype }}</div>
                      </div>
                      <div class="pl-2 mb-2">
                        <div class="caption">ข้อมูลติดต่อ</div>
                        <div>{{ item.contact }}</div>
                      </div>
                      <div class="pl-2 mb-2">
                        <div class="caption">สถานที่</div>
                        <div>{{ item.location }}</div>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </div>
        <v-dialog v-model="dialog" persistent max-width="500px" height="600px">
          <v-card v-if="dialog">
            <v-card-title>
              <h5>Send Status Message</h5>
            </v-card-title>
            <v-card-text>
              <div>
                <v-layout wrap>
                  <v-flex xs12 xm12 md12>
                    <div>
                      <label>อัพโหลดใบวางบิล/ ใบเสนอราคา</label>
                      <uploadfile v-model="input.image_url"></uploadfile>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <div class="form-control">
                      <label>Message</label>
                      <input
                        maxlength="640"
                        v-model="input.message"
                        type="text"
                        style="margin: 0"
                      />
                      <div style="text-align: right; font-size: 11px;">
                        {{ input.message.length }}/640
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <div class="form-control" style="z-index: 999">
                      <label>Status</label>
                      <multiselect
                        v-model="input.status"
                        :options="statusOptions"
                        selectLabel
                        selectedLabel
                        :searchable="false"
                        deselect-label
                      ></multiselect>
                    </div>
                  </v-flex>
                  <v-flex v-if="input.status == 'รอจ่ายเงิน'" xs12 sm12 md12>
                    <div class="form-control">
                      <label>Amount</label>
                      <input v-model="input.amount" type="number" step="0.1" style="margin: 0" />
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.native="close">Close</v-btn>
              <v-btn color="primary" :loading="sendloading" flat @click.native="sendStatus(dialog)"
                >Send</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import uploadfile from '@/components/elements/uploadfile'

export default {
  props: {
    userid: {
      value: undefined
    },
    pageid: {
      value: undefined
    }
  },
  components: {
    Multiselect,
    uploadfile
  },
  data() {
    return {
      sendloading: false,
      statusOptions: [
        'Reject',
        'ส่งใบเสนอราคา',
        'รอจ่ายเงิน',
        'จ่ายเงินแล้ว',
        'ตกลงจอง',
        'Completed',
        'Review'
      ],
      type: 'Customer',
      data: [],
      data2: [],
      loading: false,
      dialog: false,
      dialogData: '',
      input: {
        status: '',
        message: '',
        image_url: '',
        remark: '',
        amount: ''
      },
      currentpageid: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.pageid) {
      this.currentpageid = this.pageid
    } else {
      this.currentpageid = this.selectedBot.pageid
    }
    this.getallrenttransactionlivechat()
  },
  methods: {
    close() {
      this.input = {
        status: '',
        message: '',
        image_url: ''
      }
      this.dialog = false
    },
    sendStatus(id) {
      this.sendloading = true
      var vm = this
      var user = vm.data.find(el => el.id == this.dialogData)
      var data = {
        id: this.dialogData,
        status: vm.input.status,
        amount: vm.input.amount,
        message: vm.input.message,
        image_url: vm.input.image_url,
        userid: vm.userid,
        pageid: vm.currentpageid
      }
      api.putscgallrentchangestatus(data, (error, response) => {
        this.sendloading = false
        if (response.responsecode == 200) {
          vm.$swal
            .fire({
              type: 'success',
              text: 'Status sended'
            })
            .then(() => {
              this.data.find(el => el.id == this.dialogData).status = vm.input.status
              vm.close()
            })
        }
      })
    },
    showDialog(id) {
      this.dialog = true
      this.dialogData = id
      this.input.status = this.data.find(el => el.id == id).status
    },
    getallrenttransactionlivechat() {
      var data = {
        pageid: this.currentpageid,
        userid: this.userid
      }
      this.loading = true
      api.getallrenttransactionlivechat(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          this.data = response.data
          this.data2 = response.data2
        }
      })
    }
  },
  filters: {
    statusColor: function(value) {
      var color
      switch (value) {
        case 'Waiting':
          color = 'grey'
          break
        case 'Reject':
          color = '#FF6347'
          break
        case 'ส่งใบเสนอราคา':
          color = '#A52A2A'
          break
        case 'รอจ่ายเงิน':
          color = '#663399'
          break
        case 'จ่ายเงินแล้ว':
          color = 'green'
          break
        case 'ตกลงจอง':
          color = '#228B22'
          break
        case 'Completed':
          color = '#FFD700'
          break
        case 'Review':
          color = '#20B2AA'
          break

        default:
          color = 'grey'
          break
      }
      return color
    }
  },
  watch: {
    userid: function(newVal) {
      var vm = this

      if (newVal == null) {
        vm.data = []
        vm.data2 = []
      } else {
        vm.getallrenttransactionlivechat()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/scgallrent-customer.vue